<template>
  <div class="cmn_labels">
    <!-- <point-select v-model="labelParam.v1" labelText="年龄特征" :pList="codeLabelList('1001')" :config="{ isMult: true }"/>
    <point-select v-model="labelParam.v2" labelText="性别比例" :pList="codeLabelList('1002')"/>
    <point-select v-model="labelParam.v3" labelText="社区收入" :pList="LabelMapList('INCOME')" :config="{ isMult: true, placeholder: '不限' }"/>
    <point-select v-model="labelParam.v4" labelText="社区类型" :pList="LabelMapList('PLACE_TYPE')" :config="{ isMult: true, placeholder: '不限' }"/> -->
    <point-select
      v-for="(item, i) in nbhds"
      :key="item.group"
      v-model="labelParam['v'+(i+1)]"
      :labelText="item.groupName"
      :pList="item.labels"
      :config="{ isMult: true, placeholder: '不限' }">
    </point-select>
    <!-- 特殊标签 -->
    <!-- <Special v-model="labelParam.v5"/> -->
    <!-- 用户画像 -->
    <UserProfile ref="userProrileRef" v-model="profileData"/>
  </div>
</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import Special from '@/views/PutOrder/components/OrderForm/Special'
import UserProfile from '@/views/PutOrder/components/OrderForm/UserProfile'

export default {
  name: 'CommonLabels',
  components: { Special, PointSelect, UserProfile },
  data () {
    return {
      labelParam: { v1: [], v2: [], v3: [], v4: [], v5: [], v6: [], v7: [], v8: [], v9: [], v10: [] },
      profileData: [],
      nbhds: []
    }
  },
  computed: {
    codeLabelList () {
      let labelListMap = this.$store.state.bmap.labelListMap
      return code => {
        let data = labelListMap && labelListMap[code] ? labelListMap[code] : {}
        return data.list || []
      }
    },
    LabelMapList () {
      let sortMap = this.$store.state.label.sortMap
      return type =>  sortMap && sortMap[type] ? sortMap[type] : []
    },
    labelsList () {
      return this.$store.state.label.list
    }
  },
  watch: {
    labelsList: {
      immediate: true,
      handler (list) {
        if (list.length) this.initNbhdList(list)
      }
    },
    labelParam: {
      deep: true,
      handler (v) {
        let data = [];
        Object.values(v).forEach(arr => {
          data.push(...arr)
        })
        this.$emit('input', data)
      }
    },
    profileData (v) {
      this.$emit('profileChange', v)
    }
  },
  methods: {
    initNbhdList (data) {
      const kindNbhd = data.filter(e => e.kind === 'NBHD') // 小区画像相关标签
      this.nbhds = kindNbhd[0] && kindNbhd[0].groups || []
    },
    init () {
      Object.keys(this.labelParam).forEach(k => { this.labelParam[k] = [] })
      this.profileData = []
      if (this.$refs.userProrileRef) this.$refs.userProrileRef.profileDataConfirm = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .cmn_labels {
    ::v-deep .label-slt {
      margin-bottom: 10px;
      .el-form {
        .el-form-item {
          margin-bottom: 10px;
        }
      }
    }
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 0!important;
      }
    }
  }
</style>
